export const PSGIAQactions = {
  GET_PSGIAQ_ABOUTUS_AND_SECTIONS: "GET_PSGIAQ_ABOUTUS_AND_SECTIONS",
  SET_PSGIAQ_ABOUTUS_AND_SECTIONS: "SET_PSGIAQ_ABOUTUS_AND_SECTIONS",
};
